module.exports = __webpack_public_path__ + "img/tozb.034b4153.png";